export const defaultPageIndex = 1;
export const defaultPageSize = 10;
